import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=723d2100&scoped=true&"
var script = {}
import style0 from "./Book.vue?vue&type=style&index=0&id=723d2100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723d2100",
  null
  
)

export default component.exports